import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class ClientPolicyRoute extends BaseRoute {
  @service("repositories/client-policy-repository") clientPolicyRepository;
  @service("repositories/client-policy-history-repository")
  clientPolicyHistoryRepository;
  element = (<Template />);
  revalidateOnParams = ["id"];

  async loader({ params }) {
    const { id } = params;

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { clientPolicy: null };
    } else {
      try {
        const clientPolicy = await this.clientPolicyRepository.findRecord(id, {
          noCache: true,
        });
        const clientPolicyHistory = await this.clientPolicyHistoryRepository.query({
          caseId: id,
        });
        return { clientPolicy, clientPolicyHistory };
      } catch (error) {
        return { clientPolicy: null };
      }
    }
  }
}
